import layout from '@/layout/index'
import businessCenter2 from '@/module/dataCenter/page/businessManager'
import customerFlow from '@/module/dataCenter/page/customerManager'
import alarmRecordStatistic from '@/module/dataCenter/page/alarmManager'
import reportManage from '@/module/dataCenter/page/reportManage'
import dataExport from '@/module/dataCenter/page/dataExport'
import manage from '@/module/dataCenter/page/baobiao/manage'
import stationPercentageManager from '@/module/dataCenter/page/stationPercentageManager'
import i18n from '@/lang/index'
// 导出配置的路由器
export default [{
  // 默认进入此页面
  path: '/dataCenter',
  component: layout,
  redirect: 'dataCenter/businessCenter2',
  meta: {
    title: i18n.t('shu-ju-zhong-xin'),
    icon: 'icon-icon-bar-chart-o',
    perms: ['bee:dataCenter']
  },
  children: [
    {
      path: 'businessCenter2',
      component: businessCenter2,
      meta: {
        icon: 'icon-jingying',
        title: i18n.t('jing-ying-zhong-xin'),
        perms:['bee:order:businessCenter']
      }
    },
    {
      path: 'customerFlow',
      component: customerFlow,
      meta: {
        icon: 'icon-keliuxinxi',
        title: i18n.t('ke-liu-fen-xi'),
        perms:['bee:member:customerFlow']
      }
    },
    {
      path: 'alarmRecordStatistic',
      component: alarmRecordStatistic,
      meta: {
        icon: 'icon-fault',
        title: i18n.t('gu-zhang-fen-xi'),
        perms:['bee:ops:statistic']
      }
    },
    {
      path: 'stationPercentage',
      component: stationPercentageManager,
      meta: {
        icon: 'icon-chart',
        title: i18n.t('bai-fen-bi-guan-li'),
        perms:['bee:ops:percentage']
      }
    },
    {
      path: 'manage',
      component: manage,
      meta: {icon: 'icon-chart', title: i18n.t('bao-biao-guan-li'),perms:['bee:order:report']}
    }
  ]
}]



// WEBPACK FOOTER //
// ./src/module/dataCenter/router/index.js